// src/components/Soporte/SoportePanel.jsx - VERSIÓN CORREGIDA - NO BLOQUEA CLICKS

import React, { useState, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import './SoportePanel.css';

const SoportePanel = ({ usuario }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // Estados para contexto
  const [objetosUsuario, setObjetosUsuario] = useState([]);
  const [contextoSeleccionado, setContextoSeleccionado] = useState(null);
  const [cargandoObjetos, setCargandoObjetos] = useState(false);
  const [mostrarSelector, setMostrarSelector] = useState(false);
  
  const messagesEndRef = useRef(null);

  // Obtener token del usuario
  const obtenerToken = () => {
    return localStorage.getItem('nfcToken') || sessionStorage.getItem('userToken');
  };

  // Cargar objetos del usuario
  const cargarObjetosUsuario = async () => {
    const token = obtenerToken();
    if (!token) return;
    
    setCargandoObjetos(true);
    try {
      const response = await fetch('/api/objetos/mis-objetos', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const objetosActivos = (data.data || []).filter(obj => 
          obj.estado === 'activo' || obj.estado === 'pendientePorLigar'
        );
        
        setObjetosUsuario(objetosActivos);
        
        if (objetosActivos.length === 1) {
          setContextoSeleccionado(objetosActivos[0]);
          setMostrarSelector(false);
        } else if (objetosActivos.length > 1) {
          const primeraMascota = objetosActivos.find(obj => obj.tipo === 'mascota');
          setContextoSeleccionado(primeraMascota || objetosActivos[0]);
          setMostrarSelector(false);
        }
      }
    } catch (error) {
      console.error('Error cargando objetos:', error);
    } finally {
      setCargandoObjetos(false);
    }
  };

  // Íconos según tipo
  const getIconoTipo = (tipo) => {
    const iconos = {
      mascota: '🐾',
      persona: '👤',
      objeto: '📦',
      llavero: '🔑'
    };
    return iconos[tipo] || '📌';
  };

  // Obtener descripción del contexto
  const getDescripcionContexto = () => {
    if (!contextoSeleccionado) return '';
    
    const { nombre, tipo, especie, raza } = contextoSeleccionado;
    let desc = nombre;
    
    if (tipo === 'mascota' && especie) {
      desc += ` (${especie}`;
      if (raza) desc += ` ${raza}`;
      desc += ')';
    }
    
    return desc;
  };

  // Obtener acciones rápidas contextualizadas
  const obtenerAccionesRapidas = () => {
    if (!contextoSeleccionado) {
      return [
        { texto: '¿Qué plan tengo y cuándo vence?', categoria: 'cuenta' },
        { texto: '¿Cómo agregar otra mascota/objeto?', categoria: 'agregar' },
        { texto: '¿Cómo entro sin mi llavero NFC?', categoria: 'acceso' },
        { texto: '¿Por qué no me llegan los emails?', categoria: 'email' }
      ];
    }

    const { tipo, extraviado, plan, bloqueado } = contextoSeleccionado;

    if (tipo === 'mascota') {
      if (extraviado) {
        return [
          { texto: '¿Cómo aumento chances de encontrarla?', categoria: 'busqueda' },
          { texto: '¿Puedo ver quién escaneó el tag?', categoria: 'escaneos' },
          { texto: '¿Cómo marcar que ya apareció?', categoria: 'encontrada' },
          { texto: plan === 'premium' ? '¿Cómo ofrecer recompensa?' : '¿Puedo ofrecer recompensa?', categoria: 'recompensa' }
        ];
      } else {
        return [
          { texto: '¿Cómo marcar como perdida?', categoria: 'marcar_perdida' },
          { texto: '¿Cómo agregar recordatorio personal?', categoria: 'recordatorio_personal' },
          { texto: plan === 'premium' ? '¿Cómo agregar recordatorio a proveedor?' : '¿Qué son recordatorios a proveedores?', categoria: 'recordatorio_proveedor' },
          { texto: plan === 'premium' ? '¿Cómo dar de alta un proveedor?' : '¿Qué incluye plan Premium?', categoria: plan === 'premium' ? 'proveedor' : 'planes' }
        ];
      }
    }

    if (tipo === 'llavero') {
      if (bloqueado) {
        return [
          { texto: '¿Cómo desbloquear mi llavero?', categoria: 'desbloquear' },
          { texto: '¿Quién puede solicitar desbloqueo?', categoria: 'seguridad' },
          { texto: '¿Cómo entro sin mi llavero?', categoria: 'acceso_alternativo' },
          { texto: '¿Qué ve quien encuentra mi llavero?', categoria: 'privacidad' }
        ];
      } else {
        return [
          { texto: '¿Qué pasa si pierdo mi llavero?', categoria: 'llavero_perdido' },
          { texto: plan === 'premium' ? '¿Cómo bloquear acceso NFC?' : '¿Qué es bloqueo NFC?', categoria: 'bloqueo' },
          { texto: '¿Cómo entro sin mi llavero?', categoria: 'acceso_alternativo' },
          { texto: '¿Diferencia con AirTag/Tile?', categoria: 'comparacion' }
        ];
      }
    }

    if (tipo === 'persona') {
      return [
        { texto: '¿Qué información médica agregar?', categoria: 'info_medica' },
        { texto: '¿Cómo funciona en emergencias?', categoria: 'emergencia' },
        { texto: '¿Quién puede ver los datos?', categoria: 'privacidad' },
        { texto: plan === 'premium' ? '¿Cómo configurar alertas?' : '¿Qué incluye Premium?', categoria: plan === 'premium' ? 'alertas' : 'planes' }
      ];
    }

    return [
      { texto: '¿Cómo marcar como perdido?', categoria: 'marcar_perdido' },
      { texto: '¿Qué información es visible?', categoria: 'privacidad' },
      { texto: '¿Cómo actualizar datos?', categoria: 'editar' },
      { texto: `¿Qué incluye mi plan ${plan}?`, categoria: 'plan_actual' }
    ];
  };

  // Preguntas sobre la cuenta
  const obtenerPreguntasCuenta = () => {
    return [
      { texto: '¿Cuándo vence mi cuenta?', categoria: 'vencimiento' },
      { texto: '¿Cómo cambiar de plan?', categoria: 'upgrade' },
      { texto: 'No me llegan los correos', categoria: 'email' },
      { texto: 'Ver todos mis objetos', categoria: 'listar' }
    ];
  };

  useEffect(() => {
    if (isOpen && objetosUsuario.length === 0) {
      cargarObjetosUsuario();
    }
  }, [isOpen]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (isOpen && messages.length === 0) {
      const mensajeInicial = contextoSeleccionado 
        ? `¡Hola! Soy Chip. Veo que quieres hablar sobre ${contextoSeleccionado.nombre}${contextoSeleccionado.extraviado ? ' que está marcado como perdido' : ''}. ¿En qué puedo ayudarte?`
        : '¡Hola! Soy Chip, el asistente de LemmonTags. ¿En qué puedo ayudarte?';
      
      setMessages([{
        id: 1,
        tipo: 'sistema',
        texto: mensajeInicial,
        timestamp: new Date()
      }]);
    }
  }, [isOpen, messages.length, contextoSeleccionado]);

  const enviarPregunta = async (pregunta) => {
    if (!pregunta.trim()) return;

    const userMessage = {
      id: Date.now(),
      tipo: 'usuario',
      texto: pregunta,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, userMessage]);
    setInputMessage('');
    setIsLoading(true);

    try {
      const body = {
        pregunta,
        contexto: contextoSeleccionado ? {
          objetoId: contextoSeleccionado.id,
          tipo: contextoSeleccionado.tipo,
          nombre: contextoSeleccionado.nombre
        } : null
      };

      const token = obtenerToken();
      const headers = {
        'Content-Type': 'application/json'
      };
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch('/api/soporte/pregunta', {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      });

      const data = await response.json();
      
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        tipo: 'asistente',
        texto: data.respuesta || 'Lo siento, hubo un problema. Intenta de nuevo.',
        fromCache: data.fromCache,
        categoria: data.categoria,
        timestamp: new Date()
      }]);

    } catch (error) {
      console.error('Error:', error);
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        tipo: 'error',
        texto: 'No pude conectarme al servidor. Por favor intenta más tarde.',
        timestamp: new Date()
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    enviarPregunta(inputMessage);
  };

  const reiniciarConversacion = () => {
    let mensajeInicial = '¡Hola! Soy Chip, el asistente de LemmonTags.';
    
    if (contextoSeleccionado) {
      const { nombre, tipo, extraviado } = contextoSeleccionado;
      
      if (extraviado && tipo === 'mascota') {
        mensajeInicial = `Entiendo que ${nombre} está perdido. Esto debe ser muy difícil para ti. ¿Cómo puedo ayudarte a encontrarlo?`;
      } else if (tipo === 'mascota') {
        mensajeInicial = `¡Hola! Hablemos sobre ${nombre}. ¿Qué necesitas saber?`;
      } else if (tipo === 'llavero') {
        mensajeInicial = `Veo que quieres información sobre tu llavero ${nombre}. ¿En qué puedo ayudarte?`;
      } else {
        mensajeInicial = `Hablemos sobre ${nombre}. ¿Qué necesitas?`;
      }
    }
    
    setMessages([{
      id: Date.now(),
      tipo: 'sistema',
      texto: mensajeInicial,
      timestamp: new Date()
    }]);
    setInputMessage('');
  };

  const SelectorContexto = () => {
    if (cargandoObjetos) {
      return (
        <div className="selector-contexto cargando">
          <i className="bi bi-arrow-repeat spin"></i> Cargando tus objetos...
        </div>
      );
    }

    if (objetosUsuario.length === 0) {
      return null;
    }

    if (mostrarSelector) {
      return (
        <div className="selector-contexto">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="small mb-0">¿Sobre qué quieres preguntar?</p>
            {contextoSeleccionado && (
              <button 
                className="btn btn-sm btn-link p-0"
                onClick={() => setMostrarSelector(false)}
              >
                <i className="bi bi-chevron-up"></i>
              </button>
            )}
          </div>
          <div className="opciones-contexto">
            {objetosUsuario.map(obj => (
              <button
                key={obj.id}
                className={`btn-contexto ${contextoSeleccionado?.id === obj.id ? 'activo' : ''}`}
                onClick={() => {
                  setContextoSeleccionado(obj);
                  setMostrarSelector(false);
                  if (contextoSeleccionado?.id !== obj.id) {
                    reiniciarConversacion();
                  }
                }}
              >
                <span className="icono">{getIconoTipo(obj.tipo)}</span>
                <div className="info-contexto">
                  <span className="nombre">{obj.nombre}</span>
                  <span className="tipo-badge">{obj.tipo}</span>
                </div>
                {obj.extraviado && <span className="badge bg-danger ms-auto">Perdido</span>}
              </button>
            ))}
          </div>
        </div>
      );
    }

    if (contextoSeleccionado && !mostrarSelector) {
      return (
        <div className="contexto-activo">
          <span className="badge bg-primary">
            {getIconoTipo(contextoSeleccionado.tipo)} Hablando sobre: {getDescripcionContexto()}
          </span>
          {objetosUsuario.length > 1 && (
            <button 
              className="btn btn-sm btn-link"
              onClick={() => setMostrarSelector(true)}
            >
              Cambiar
            </button>
          )}
        </div>
      );
    }

    return null;
  };

  return (
    <>
      {/* ✅ Botón SIEMPRE recibe clicks */}
      <button
        className="btn-soporte-ia"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir soporte"
      >
        {isOpen ? (
          <i className="bi bi-x-lg"></i>
        ) : (
          <>
            <i className="bi bi-chat-dots-fill"></i>
            {contextoSeleccionado && (
              <span className="contexto-badge">
                {getIconoTipo(contextoSeleccionado.tipo)}
              </span>
            )}
          </>
        )}
      </button>

      {/* ✅ Panel SOLO se renderiza cuando está abierto */}
      {isOpen && (
        <div className="soporte-panel open">
          <div className="soporte-header">
            <div className="d-flex align-items-center">
              <i className="bi bi-robot me-2"></i>
              <h6 className="mb-0">Chip - Asistente LemmonTags</h6>
            </div>
            <div className="d-flex align-items-center gap-2">
              {messages.length > 1 && (
                <button 
                  className="btn-header-action"
                  onClick={reiniciarConversacion}
                  title="Nueva conversación"
                  aria-label="Nueva conversación"
                >
                  <i className="bi bi-arrow-clockwise"></i>
                </button>
              )}
              <button 
                className="btn-close"
                onClick={() => setIsOpen(false)}
                aria-label="Cerrar"
              />
            </div>
          </div>

          <SelectorContexto />

          <div className="soporte-body">
            {messages.length <= 1 && !mostrarSelector && (
              <div className="acciones-rapidas">
                <p className="small text-muted mb-2">
                  {contextoSeleccionado 
                    ? `Sobre ${contextoSeleccionado.nombre}:`
                    : 'Preguntas frecuentes:'}
                </p>
                {obtenerAccionesRapidas().map((accion, idx) => (
                  <button
                    key={idx}
                    className="btn btn-outline-primary btn-sm m-1"
                    onClick={() => enviarPregunta(accion.texto)}
                    disabled={isLoading}
                  >
                    {accion.texto}
                  </button>
                ))}
                
                {contextoSeleccionado && (
                  <>
                    <hr className="my-2" />
                    <p className="small text-muted mb-2">Sobre tu cuenta:</p>
                    {obtenerPreguntasCuenta().map((accion, idx) => (
                      <button
                        key={`cuenta-${idx}`}
                        className="btn btn-outline-secondary btn-sm m-1"
                        onClick={() => enviarPregunta(accion.texto)}
                        disabled={isLoading}
                      >
                        {accion.texto}
                      </button>
                    ))}
                  </>
                )}
              </div>
            )}

            <div className="mensajes-container">
              {messages.map(mensaje => (
                <div
                  key={mensaje.id}
                  className={`mensaje mensaje-${mensaje.tipo}`}
                >
                  <div className="mensaje-texto">
                    {mensaje.tipo === 'asistente' || mensaje.tipo === 'sistema' ? (
                      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{mensaje.texto}</ReactMarkdown>
                    ) : (
                      mensaje.texto
                    )}
                  </div>
                </div>
              ))}
              {isLoading && (
                <div className="mensaje mensaje-asistente">
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>
          </div>

          <form onSubmit={handleSubmit} className="soporte-input">
            <div className="input-group">
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder={contextoSeleccionado 
                  ? `Pregunta sobre ${contextoSeleccionado.nombre}...` 
                  : "Escribe tu pregunta..."}
                disabled={isLoading}
                className="form-control"
                maxLength={200}
              />
              <button 
                type="submit" 
                disabled={isLoading || !inputMessage.trim()}
                className="btn btn-primary"
              >
                <i className="bi bi-send-fill"></i>
              </button>
            </div>
          </form>

          <div className="soporte-footer">
            <small className="text-muted">
              Powered by IA • <a href="#" onClick={(e) => { 
                e.preventDefault(); 
                window.location.href = 'mailto:soporte@lemmontags.com';
              }}>Contacto humano</a>
            </small>
          </div>
        </div>
      )}
    </>
  );
};

export default SoportePanel;